import React from "react";

const DriverPayment = ({
    driverHourlyPrice,
    driverNdsTypeId,
    driverPaymentTypeId,
    driverPrice,
    renderSelect,
    renderField,
}) => (
    <>
        <div className="form-group">
            <strong>Оплата водителю</strong>
        </div>
        {renderSelect(driverPaymentTypeId)}
        {renderSelect(driverNdsTypeId)}
        {renderField(driverPrice)}
        {renderField(driverHourlyPrice)}
        <div className="book-form__separator" />
    </>
);

export default DriverPayment;
